module.exports = "<div style=\"margin: auto;\">\r\n    <h2>You are currently not logged in. Please use the \"Login\" button above.</h2>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/auth/components/login-unauthorised.component.html
// module id = ./src/app/auth/components/login-unauthorised.component.html
// module chunks = main